import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class FordCrossingTileEntity2 extends TileEntity {
	public static readonly frameName = FrameName.FORD_CROSSING_2;
}

export default FordCrossingTileEntity2;
